import { MxBaseMask } from './mx-mask-base';

export class MxColorMask extends MxBaseMask {
	constructor() {
		super();
		this.parseAttributes = ['mxMaskFormat'];
	}

	createFormatter() {
		return function (value) {
			return value;
		};
	}
	createParser(ngModel) {
		return function (value) {
			if (ngModel.$viewValue !== value) {
				ngModel.$setViewValue(value);
				ngModel.$render();
			}

			return value;
		};
	}
	iniialize(options) {
		const pattern = 'BXXXXXX';
		Object.assign(options, {
			translation: {
				B: { pattern: /#/ },
				X: { pattern: /[a-fA-F0-9]/ },
			},
		});
		this.viewMask = this.createMask(pattern, options);
	}
}
